module.exports = __webpack_public_path__ + "static/qualitative-vs-quantitative-fcac61a65321c906d9af865e9a22b3ad.png";